import React, { useEffect, useState } from 'react'
import { Carousel } from 'react-bootstrap'
import '../../css/topbarimgslider.css'
import axios from 'axios'

const TopbarImgSlider = () => {

    axios.defaults.withCredentials = true;

    const [topbarImgSlider, setTopbarImgSlider] = useState([]);

    const fetchTopbarImg = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/topbar-image-slider`);
            if (response.data.status === "Success") {
                setTopbarImgSlider(response.data.detail);
            }
            else {
                console.error("Unable to Get img data!", response.data.errorDetail);
            }
        }
        catch (error) {
            console.error("Error Fetching Data!", error);
        }
    }

    useEffect(() => {
        fetchTopbarImg();
    }, [])

    return (
        <>
            <div className='logo-slider-section'>
                <Carousel interval={3500} controls={false} indicators={false}>

                    {topbarImgSlider.length > 0 ? (
                        topbarImgSlider.map((item, idx) => {
                            console.log('ImgPath:', `${process.env.REACT_APP_IMG_URL}/imageSlider/${item.PhotoIm}`);
                            return (
                                <Carousel.Item key={idx}>
                                    <img className="logoslide-img" src={`${process.env.REACT_APP_IMG_URL}/imageSlider/${item.PhotoIm}`} alt={item.Title} crossOrigin='anonymous' />
                                </Carousel.Item>
                            )
                        })
                    ) : (
                        <span>No Record Found!</span>
                    )}

                </Carousel>
            </div>
        </>
    )
}

export default TopbarImgSlider